__turbopack_context__.v({
  "accordion": "IVnBEW_accordion",
  "card": "IVnBEW_card",
  "cardHidden": "IVnBEW_cardHidden",
  "cards": "IVnBEW_cards",
  "controls": "IVnBEW_controls",
  "remark": "IVnBEW_remark",
});
